import styled from 'styled-components';
import { Space } from '@10d/tend-ui-grid';

import { colors } from '@10d/tend-ui-tokens/samolet';

export const InlineBody = styled(Space)`
  background-color: ${colors.gray0};
  box-shadow: 0px 0px 12px #d7dce9;
  border-radius: 4px;
  padding: 24px;
  max-width: 1200px;
`;
